import { IPageParams } from "@/api/types";

export function makeCommonQuery(): IPageParams {
    return {
        pageNum: 1,
        pageSize: 10,
    }
}
